// Single source of truth for brand assets and copy.
// The PNG lives in /public/brand/ so React can reference it as a URL.

export const BRAND_LOGO = "/brand/cgi-logo.png";
export const BRAND_NAME = "Common Ground Institute";
export const BRAND_PROGRAM = "Relationship Check-in";
export const BRAND_WEBSITE = "https://www.commongroundinstitute.net";

/**
 * Clickable CGI logo. Renders as an external anchor to the institute's website,
 * opens in a new tab. Callers must NOT wrap this in another <Link>/<a>.
 */
export const BrandMark = ({ className = "h-8 w-auto", alt = BRAND_NAME }) => (
  <a
    href={BRAND_WEBSITE}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="brand-logo-link"
    title="Visit Common Ground Institute"
    className="inline-flex items-center focus:outline-none focus:ring-2 focus:ring-[#C86B5E] focus:ring-offset-2 focus:ring-offset-[#FDFBF7] rounded-md"
  >
    <img
      src={BRAND_LOGO}
      alt={alt}
      className={className}
      data-testid="brand-logo"
      loading="eager"
      decoding="async"
    />
  </a>
);
